import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "good-road-timer-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", {
  fill: "none",
  stroke: "#4b422e",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "11.5",
    cy: "11.5",
    r: "11.5",
    stroke: "none"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "11.5",
    cy: "11.5",
    r: "10.5",
    fill: "none"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("line", {
  y1: "7",
  transform: "translate(11.5 4.5)",
  fill: "none",
  stroke: "#4b422e",
  "stroke-linecap": "round",
  "stroke-width": "2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("line", {
  x2: "4",
  y2: "4",
  transform: "translate(11.5 11.5)",
  fill: "none",
  stroke: "#4b422e",
  "stroke-linecap": "round",
  "stroke-width": "2"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}